export const theme = {
    color: {
        white: "#FFFFFF",
        blue: "#2517EB",
        iron: "#D1D5DA",
        ironOpacity30: "#D1D5DA4D",
        ironOpacity10: "#D1D5DA1A",
        scienceBlue: "#0366D6",
        scienceBlueOpacity20: "#0366D633",
        scienceBlueOpacity50: "#0366D680",
        slateGray: "#6E7E91",
        mineShaft: "#252525",
        lighterMineShaft: "#363636",
        lighterMineShaftOpacity: "#363636B3",
        whiteLilac: "#FBFBFE",
        dodgerBlue: "#2188FF",
        dodgerBlueOpacity80: "#2188FFCC",
        dodgerBlueOpacity80: "#2188FF66",
        mercury: "#E5E5E5",
        alto: "#DADADA",
    },
    breakpoint: {
        mobileInit: 1210,
        mobileMax: 1060,
    },
};